export default __webpack_public_path__ + "static/media/calendar.faca9606.svg";